import { render, staticRenderFns } from "./nameList.vue?vue&type=template&id=2cd42369"
import script from "./nameList.vue?vue&type=script&lang=js"
export * from "./nameList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports